import FooterWidget from 'nucleus-widgets/lib/Footer/FooterWidget';
import { connect } from 'react-redux';
import { getPrivacyPolicyLink as getPrivacyPolicyURL } from '../../utils/privacyPolicyUtils';

function getPrivacyPolicyLinks(state, config) {
  const links = [];

  if (config.cventPrivacyPolicy.visible) {
    links.push({
      url: getPrivacyPolicyURL(state.event.languageId || state.event.cultureCode),
      text: config.cventPrivacyPolicy.text
    });
  }

  if (config.plannerPrivacyPolicy.visible) {
    links.push({
      url: config.plannerPrivacyPolicy.url,
      text: config.plannerPrivacyPolicy.text
    });
  }

  return links;
}

/* Data wrapper for the footer widget */
export default connect((state) => ({
  allowCustomFooter: state.account.settings.allowCustomEventFooter,
  showPrivacyPolicy: false,
  additionalPolicyLinks: getPrivacyPolicyLinks(state, state.website.layoutItems.CventFooterSection.config)
}))(FooterWidget);
